import styled from 'styled-components';

export const Container = styled.div`
    display: grid;
    justify-content: center;
    align-content: center;
    width: 100vw;
    height: 100vh;
    background: linear-gradient(to bottom right, #3a70e8 0%, #99d2ff 100%);
    /* background-image: url('https://www.pictureeuropa.com/wp-content/uploads/2019/09/4k-nature-wallpapers-ultra-hd-62.jpg'); */
    background-size: cover;

    > img {
        position:absolute;
        height: 100vh;
        width: 100vw;
    }
    /* backdrop-filter: blur(7px) saturate(180%); */
`;
export const Content = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    width: 500px;
    height: 400px;
    font-family: 'Roboto', sans-serif;
	color: #333;
    box-shadow: 0px 0px 50px -12px rgba(0, 0, 0, 0.69);
    border-radius: 5px;
    transition-duration: .5s;
    z-index: 10;


`;

export const ContentLogin = styled.div`
    background: #fff;
    border-radius: 5px;
    padding: 15px;
    display:flex;
    flex:1;
    flex-direction:column;
    justify-content: space-around;
    align-items:  center;
    color: rgba(0, 0, 0, 0.87);
    /* backdrop-filter: blur(7px) saturate(180%); */

    > div > h3 {
        text-align:center;
        font-size:24px;
    }
    > form {
        display:flex;
        /* flex:1; */
        flex-direction:column;
        justify-content: center;
        align-items:  center;
        width: 100%;
    }
    > form > div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        margin-top: 15px;
    }
    > form > div > a {
        font-size: 14px;
        text-decoration: initial;
        color: rgba(0,0,0,0.87);
        padding-top: 4px;
    }
`;
export const ContentInput = styled.div`
    margin-top:0px!important;
    position: relative;

    > input {
        width:100%;
        margin: 10px 0px;
        padding: 10px 20px 10px 5px;
        border: none;
        border-bottom: 1px solid #cecece;
    }
    > svg {
        color: rgba(0,0,0,0.87);
        position: absolute;
        top: 19px;
        right: 5px;
    }
`;
export const ContentLogo = styled.div`
    background: #fff;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    /* background-image: url('https://image.shutterstock.com/z/stock-photo-blur-image-of-modern-laboratory-for-pharmacy-background-usage-485148412.jpg'); */
    background: linear-gradient(to bottom right, #00515e 0%, #00c5d2 100%);
    display: grid;
    justify-content: center;
    align-content: space-around;
    text-align:center;
    padding: 80px;
    > div {
        width: 80%;
        margin: auto;
        color:#fff;
    }
    > div > img {
        width: 35%;
    }
    > div > span {
        font-size: 20px;
        font-weight: 400;
        word-spacing: 3px;
    }
`;

export const ButtonPromo = styled.button`
    margin: auto;
    margin-top: 40px;
    padding: 10px 30px;
    width: 100%;
    border: none;
    background: linear-gradient(to right,#1b1b1b 0%,#5a5a5a 100%);
    color: #ffffff;
    font-size: 16px;
    /* font-weight: unset; */
    letter-spacing: 2px;
    border-radius: 25px;
    cursor: pointer;

    &:hover {
        transition: 0.3s ease-out;
        opacity: 0.91
    }

`;

export const Saudacoes = styled.h1`
    color: #fff;
    font-size: 5rem;
    display: none;

`;
